export default "__VITE_ASSET__Dfxcad4p__"